/**
 * <dogscan-study> — animated counters on scroll-in. Respects reduced-motion.
 * INSTALL: upload to the theme's assets/.
 */
if (!customElements.get('dogscan-study')) {
  const REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(n, decimals) {
    if (decimals) return n.toFixed(decimals).replace('.', ',');
    return Math.round(n).toLocaleString('de-DE');
  }

  function runCount(el) {
    const target = parseFloat(el.dataset.count);
    const decimals = el.dataset.decimals === '1' ? 1 : 0;
    const suffix = el.dataset.suffix || '';
    const wrap = (txt) => suffix
      ? txt + '<span class="dogscan-study__suffix">' + suffix + '</span>'
      : txt;
    if (REDUCE || !target) { el.innerHTML = wrap(fmt(target || 0, decimals)); return; }
    const dur = 1500;
    const start = performance.now();
    function tick(now) {
      const t = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - t, 3);
      el.innerHTML = wrap(fmt(target * eased, decimals));
      if (t < 1) requestAnimationFrame(tick);
      else el.innerHTML = wrap(fmt(target, decimals));
    }
    requestAnimationFrame(tick);
  }

  class DogscanStudy extends HTMLElement {
    connectedCallback() {
      const els = Array.from(this.querySelectorAll('.dogscan-study__num'));
      if (!els.length) return;
      if (REDUCE) { els.forEach(runCount); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          runCount(e.target);
          io.unobserve(e.target);
        });
      }, { threshold: 0.6 });
      els.forEach((el) => io.observe(el));
    }
  }
  customElements.define('dogscan-study', DogscanStudy);
}
